export default __webpack_public_path__ + "static/media/ic-person.620dfa12.svg";